module.exports = __webpack_public_path__ + "static/media/cafeImg_1.3ea6ab26.png";